/**
 * Created by zhouchenwen on 2017/9/11.
 */
cb.define([], function () {
  var ST_st_demandapplylist_VM_extend = {

    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
      //新增前事件
      var promise = null;
      viewmodel.on('afterOkClick', function (args) {
        if (args.key === 'IntelligenceDemand') {
          var externalData = {};
          externalData.busitype = 2;
          // var saleDate = {};
          // saleDate.startDate = args.value.saleDate.startDate;
          // saleDate.endDate = args.value.saleDate.endDate;
          externalData.saleDate = args.value.saleDate;
          promise.resolve(externalData);
        }
      });
      viewmodel.on("beforeAdd", function (data) {
        let cItemName = data.params.params.cItemName;
        var externalData = {};
        if (cItemName == "btnAdd" || cItemName == "btnNomal") {
          externalData.busitype = 1;
          data.params.carryParams.externalData = externalData;
        } else if (cItemName == "btnIntelligence") {
        //  data.params.carryParams.externalData = 2;
          externalData.busitype = 2;
          promise = new cb.promise();
          viewmodel.communication({
            type: 'modal',
            payload: {
              key: 'IntelligenceDemand',
              data: {
                model: viewmodel
              }
            }
          });
          return promise;
        } else if (cItemName == "btnCustomized") {
          externalData.busitype = 3;
          data.params.carryParams.externalData = externalData;
        }
        console.log("ddd");
      });
      //根据单据状态，设置行上的按钮是否显示
      viewmodel.get("st_demandapply").on("afterSetDataSource", function (rows) {
        var actions = this.getCache("actions");
        var actionStates = [];
        rows.forEach(function (row) {
          var status = row.bizstatus;
          var actionState = {};
          if (status == 0) {
            //保存状态: 查看，修改，提交，删除
            actions.forEach(function (action) {
              actionState[action.cItemName] = { visible: true };
            })
          } else {
            //其他状态：查看
            actions.forEach(function (action) {
              actionState[action.cItemName] = { visible: false };
            });
          }
          if (status == 1 && row.exchangestatus == 1) {//提交并且交换失败 wangyda
            actionState["btnRevoke"] = { visible: true };
          }else{
            actionState["btnRevoke"] = { visible: false };
          }
          actionStates.push(actionState);
        });
        this.setActionsState(actionStates);
      });
    }
  }
  try {
    module.exports = ST_st_demandapplylist_VM_extend;
  } catch (error) {

  }
  return ST_st_demandapplylist_VM_extend;
});



// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_demandapplylist_VM.Extend.js